module.exports = __webpack_public_path__ + "static/media/thirdPlaceMedal.e8647477.svg";